module.exports = __webpack_public_path__ + "static/media/Image 12.fefeae4c.png";